<div class="course-details" [class.dialog-mode]="dialogMode">
  <ng-scrollbar thumbClass="custom-scrollbars" visibility="hover">
    <div class="course-banner">
      <div class="course-media">
        <div class="image-placeholder" [placeholderImage]="!item?.mediaImage && item?.bundle"></div>

        @if (isLoading && !item) {
          <lib-skeleton-loader class="image-loading-placeholder" width="100%" height="100%"></lib-skeleton-loader>
        }

        @if (item?.trailer) {
          <div class="course-video" (click)="playTrailer()" [class.video-playing]="videoPlayer?.plyr?.playing">
            <button mat-flat-button class="button button--gray video-play-button">
              <lib-icon [icon]="videoPlayer?.plyr?.playing ? 'pause' : 'play'"></lib-icon>
              <span class="video-play-button-text">
                {{ 'COURSE_DETAILS.watch_trailer' | translate }}
              </span>
            </button>
            <lib-video class="course-video-player" [src]="item.trailer | videoPresign | async" [hideControls]="true" type="video/mp4"
              [video]="item.trailer" (started)="logUserActivity(activityTypes.USER_START_WATCHING_VIDEO)"
              (watched)="logUserActivity(activityTypes.USER_WATCHED_VIDEO)"
              [poster]="{ uri: item.mediaImage | preSignedUrl | async | imageCrop : item.mediaImage?.crop | async }">
            </lib-video>
          </div>
        } @else {
          <div class="course-image" [cropImage]="item?.mediaImage | preSignedUrl | async" [additionalOptions]="{ aspect_ratio: '16:9' }"
          [crop]="item?.mediaImage?.crop"></div>
        }

      </div>

      @if (!dialogMode) {
        <ng-container *ngTemplateOutlet="baseInformationTmp"></ng-container>
      }

    </div>

    <div class="course-details-body">
      @if (dialogMode) {
        <ng-container *ngTemplateOutlet="baseInformationTmp"></ng-container>
      }

      <mat-tab-group
        class="courses-tabs"
        [disableRipple]="true"
        [disablePagination]="true"
        [mat-stretch-tabs]="false"
        animationDuration="200"
        (selectedTabChange)="tabChanged($event)">

        <mat-tab [disabled]="!item">
          <ng-template mat-tab-label>
            <label class="course-tab-label">
              {{ 'COURSE_DETAILS.details' | translate }}
            </label>
          </ng-template>

          <ng-template matTabContent>
            @if (item) {
              <div class="course-tab-content course-about-tab">
                <div class="course-main-info">
                  <div class="course-info-section">
                    <h3 class="tab-content-title">
                      {{ 'COURSE_DETAILS.about_course' | translate }}
                    </h3>
                    <div class="course-description" [innerHTML]="item.description | safeHtml"></div>
                    @if (item.relatedLearningPaths?.[0]) {
                      <span class="course-learning-path">
                        {{ 'COURSE_DETAILS.part_of' | translate }}
                        <lib-icon class="learning-path-icon" icon="path" size="16"></lib-icon>
                        <strong class="learning-path-title">{{ item.relatedLearningPaths?.[0]?.title }}</strong>
                      </span>
                    }
                  </div>
                  <div class="course-info-section">
                    <h4 class="tab-content-title tab-content-title--sub">
                      {{ 'COMMON.achievements' | translate }}
                    </h4>
                    <div class="course-achievements">
                      <ng-container *ngIfFeature="featuresKey.LEADERBOARD">
                        @if (item.leaderboardPoints) {
                          <div class="course-achievement-item">
                            <div class="achievement-icon achievement-icon--purple">
                              <lib-icon size="36" icon="currency-eth"></lib-icon>
                            </div>
                            <div class="achievement-info">
                              <h6 class="achievement-title">+ {{item.leaderboardPoints}}</h6>
                              <span>{{'COMMON.experience_points' | translate}}</span>
                            </div>
                          </div>
                        }
                      </ng-container>
                      <ng-container *ngIfFeature="featuresKey.ACHIEVEMENTS">
                        @if (item.achievementEnabled) {
                          <div class="course-achievement-item">
                            <div class="achievement-icon achievement-icon--purple">
                              <lib-icon size="36" icon="medal"></lib-icon>
                            </div>
                            <div class="achievement-info">
                              <h6 class="achievement-title">{{ item?.achievements?.[0]?.title }}</h6>
                              <span>{{'COMMON.badge' | translate}}</span>
                            </div>
                          </div>
                        }
                      </ng-container>
                      <ng-container *ngIfFeature="featuresKey.CERTIFICATES">
                        @if (item.certificationEnabled) {
                          <div class="course-achievement-item">
                            <div class="achievement-icon achievement-icon--green">
                              <lib-icon size="36" icon="certificate"></lib-icon>
                            </div>
                            <div class="achievement-info">
                              <h6 class="achievement-title">{{ item?.certifications?.[0]?.title }}</h6>
                              <span>{{'COMMON.certificate' | translate}}</span>
                            </div>
                          </div>
                        }
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="course-stats">
                  @if (item.time) {
                    <div class="course-stat">
                      <lib-icon icon="clock"></lib-icon>
                      {{ item.time | minutesToTime : 'short' }}
                    </div>
                  }
                  <div class="course-stat">
                    <lib-icon icon="book-open-text"></lib-icon>
                    {{ 'COMMON.lessons_count' | translate : { count: item.lessonsCount } }}
                  </div>
                  <div class="course-stat">
                    <lib-icon icon="game-controller"></lib-icon>
                    {{ 'COMMON.quizzes_count' | translate : { count: item.quizzesCount } }}
                  </div>
                  @if (item.filesCount) {
                    <div class="course-stat">
                      <lib-icon icon="stack"></lib-icon>
                      {{ 'COMMON.additional_materials' | translate : { count: item.filesCount } }}
                    </div>
                  }
                  @if (audioLanguages?.length) {
                    <div class="course-stat">
                      <lib-icon icon="headphones"></lib-icon>
                      {{'COMMON.audio' | translate }}: {{ audioLanguages }}
                    </div>
                  }
                  @if (languages?.length) {
                    <div class="course-stat">
                      <lib-icon icon="globe"></lib-icon>
                      {{'COMMON.languages' | translate }}: {{ languages }}
                    </div>
                  }
                  <ng-container *ngIfFeature="featuresKey.CERTIFICATES">
                    @if (item.certificationEnabled) {
                      <div class="course-stat">
                        <lib-icon icon="certificate"></lib-icon>
                        {{'COMMON.certificate' | translate}}
                      </div>
                    }
                  </ng-container>
                  <ng-container *ngIfFeature="featuresKey.LEADERBOARD">
                    @if (item.leaderboardPoints) {
                      <div class="course-stat">
                        <lib-icon icon="currency-eth"></lib-icon>
                        {{ 'LEADERBOARD.points_count' | translate : { count: item.leaderboardPoints } }}
                      </div>
                    }
                  </ng-container>
                </div>
              </div>
            }
          </ng-template>
        </mat-tab>

        @if (item?.lessonsCount + item?.quizzesCount) {
          <mat-tab>
            <ng-template mat-tab-label>
              <label class="course-tab-label">
                {{ 'COMMON.lesson_and_quizzes' | translate }}
                <span class="label-counter">
                  {{ item?.lessonsCount + item?.quizzesCount }}
                </span>
              </label>
            </ng-template>
            <ng-template matTabContent>
              @if (item) {
                <div class="course-tab-content list-content-tab">
                  <h3 class="tab-content-title">
                    {{ 'COMMON.lesson_and_quizzes' | translate }}
                  </h3>
                  @for (child of modules; track child; let first = $first) {
                    <app-module-content-expansion-panel
                      [id]="child.id"
                      [title]="child.title"
                      [titleHidden]="skipModules || modules?.length === 1"
                      [quizzesCount]="child.quizzesCount"
                      [lessonsCount]="child.lessonsCount"
                      [autoOpen]="first">
                    </app-module-content-expansion-panel>
                  }
                  @if (contentLoading) {
                    <ng-container *ngTemplateOutlet="cardsPlaceholder"></ng-container>
                  }
                </div>
              }
            </ng-template>
          </mat-tab>
        }

        <ng-container *ngIfFeature="[featuresKey.WEBINARS, featuresKey.IN_PERSON_EVENTS]">
          @if (item && item?.webinarsCount) {
            <mat-tab>
              <ng-template mat-tab-label>
                <label class="course-tab-label">
                  {{ 'COMMON.webinars' | translate }}
                  <span class="label-counter">{{item.webinarsCount}}</span>
                </label>
              </ng-template>
              <ng-template matTabContent>
                @if (item) {
                  <div class="course-tab-content list-content-tab">
                    <h3 class="tab-content-title">
                      {{ 'COMMON.webinars' | translate }}
                    </h3>
                    @for (item of webinars; track item) {
                      <app-event-card
                        [item]="item"
                        [orientation]="cardOrientation">
                      </app-event-card>
                    }
                    @if (contentLoading) {
                      <ng-container *ngTemplateOutlet="cardsPlaceholder"></ng-container>
                    }
                  </div>
                }
              </ng-template>
            </mat-tab>
          }
        </ng-container>

      </mat-tab-group>
    </div>
  </ng-scrollbar>
</div>

<ng-template #baseInformationTmp>
  <div class="course-base-info">
    <div class="bundle-label">{{'COMMON.course' | translate }}</div>

    <h1 class="course-title">
      @if (isLoading && !item?.title) {
        <lib-skeleton-loader width="320px" height="48px"></lib-skeleton-loader>
      }

      {{item?.title}}

      @if (item?.isLocked) {
        <lib-icon icon="lock-simple" ></lib-icon>
      }

    </h1>

    <div class="course-actions">
      <button mat-flat-button class="button button--primary button--large" (click)="navigate()" [disabled]="!item || item.isLocked" cdkFocusInitial>
        @if (!item || (!paymentEnabled || !item?.payable || item?.isPaid)) {
          <lib-icon icon="play"></lib-icon>
          {{ 'COMMON.start_course' | translate }}
        } @else {
          <lib-icon icon="shopping-cart"></lib-icon>
          {{ 'COMMON.buy_course' | translate }}
          {{ item?.price | currency:( item?.currency | uppercase):'symbol' }}
        }


      </button>
    </div>
  </div>
</ng-template>

<ng-template #cardsPlaceholder>
  @for (item of placeholders; track $index) {
    <lib-skeleton-loader class="skeleton-card"></lib-skeleton-loader>
  }
</ng-template>
